module.exports = __webpack_public_path__ + "img/xcx.bf80ba68.jpeg";